import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";

import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { WhyUs } from "@/components/site/WhyUs";
import { Gallery } from "@/components/site/Gallery";
import { QuoteCTABanner } from "@/components/site/QuoteCTABanner";
import { Testimonials } from "@/components/site/Testimonials";
import { GoogleReviews } from "@/components/site/GoogleReviews";
import { FAQ } from "@/components/site/FAQ";
import { Footer } from "@/components/site/Footer";
import { StickyMobileCTA } from "@/components/site/StickyMobileCTA";
import { YouTubeVideos } from "@/components/site/YouTubeVideos";
import { QuotePopup } from "@/components/site/QuotePopup";
import { BlogPreview } from "@/components/site/BlogPreview";

import DenverLanding from "@/pages/DenverLanding";
import AdminPage from "@/pages/AdminPage";
import TermsPage from "@/pages/TermsPage";
import ContractPage from "@/pages/ContractPage";
import PrivacyPage from "@/pages/PrivacyPage";
import QuotePage from "@/pages/QuotePage";
import EpoxyPage from "@/pages/EpoxyPage";
import BlogPage from "@/pages/BlogPage";
import ArticlePage from "@/pages/ArticlePage";
import NotFoundPage from "@/pages/NotFoundPage";

const HOME_CANONICAL = "https://alldaypowerwashing.com/";

const Home = () => {
  return (
    <div className="App" data-testid="landing-page">
      <Helmet>
        <link rel="canonical" href={HOME_CANONICAL} />
        <meta property="og:url" content={HOME_CANONICAL} />
      </Helmet>
      <Header />
      <Hero />
      <Gallery />
      <YouTubeVideos />
      <Services />
      <WhyUs />
      <QuoteCTABanner />
      <Testimonials />
      <GoogleReviews />
      <BlogPreview />
      <FAQ />
      <Footer />
      <StickyMobileCTA />
      <QuotePopup />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#142238",
              color: "#fff",
              border: "1px solid #1E293B",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/epoxy" element={<EpoxyPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />
          <Route path="/denver" element={<DenverLanding />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contract" element={<ContractPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
